<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterLink } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'
import { useAuth } from '@/composables/useAuth'
import { useAgreement } from '@/composables/useAgreement'

const { user, role } = useAuth()
const { agreement, loading, error, refresh } = useAgreement()

onMounted(async () => {
  try { await refresh() } catch { /* The page displays the error state. */ }
})
</script>

<template>
  <AppLayout>
    <header class="page-heading">
      <p class="eyebrow">MY PROFILE</p>
      <h1>{{ user?.displayName || user?.email || 'Portal account' }}</h1>
      <p>{{ user?.email }} · <span class="profile-role">{{ role }}</span></p>
    </header>

    <section class="profile-grid">
      <article class="panel">
        <p class="eyebrow">ACCOUNT ACCESS</p>
        <h2>AM Church AV Portal</h2>
        <p class="muted">Your assigned access level is <b class="profile-role">{{ role }}</b>.</p>
      </article>
      <RouterLink to="/agreement" class="panel profile-agreement">
        <p class="eyebrow">PORTAL AGREEMENT</p>
        <h2>{{ agreement?.policy.title || 'Your portal agreement' }}</h2>
        <p v-if="agreement?.accepted" class="notice">Accepted{{ agreement.acceptance?.acceptedAt ? ` · ${new Date(agreement.acceptance.acceptedAt).toLocaleString()}` : '' }}</p>
        <p v-else-if="loading" class="muted">Loading agreement status…</p>
        <p v-else-if="error" class="error">Unable to load agreement status.</p>
        <p v-else class="muted">Review agreement →</p>
      </RouterLink>
    </section>
  </AppLayout>
</template>
